module.exports = __webpack_public_path__ + "static/scale-model-of-springfield-massachusetts-313f9c234ddb30aaac2461dae297eef8.png";